import React, { useState, useEffect } from 'react';
import L from 'leaflet';
import Papa from 'papaparse';
import zoneData from './../data/zoneData.json';

function UploadAddressChecker() {
  const [map, setMap] = useState(null);
  const [inCount, setInCount] = useState(null);
  const [outCount, setOutCount] = useState(null);
  const [addressNotFoundCount, setAddressNotFoundCount] = useState(null);
  const [markers, setMarkers] = useState([]);

  useEffect(() => {
    console.log("UploadAddressChecker");
    const newMap = L.map('uploadmap').setView([38.5, -96.5], 4);
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 18,
      attribution: 'Map data © OpenStreetMap contributors',
    }).addTo(newMap);
    setMap(newMap);

    return () => {
      if (map) {
        map.remove();
      }
    };
  }, []);

  useEffect(() => {
    if (map) {

      const zoneLayer = L.geoJSON(zoneData, {
        style: {
          color: '#3498db',
          fillOpacity: 0.2,
          weight: 2,
        },
        onEachFeature: (feature, layer) => {
          const name = feature.properties.NAME;
          layer.bindPopup(`<strong>${name}</strong>`);
        },
      }).addTo(map);
      map.fitBounds(zoneLayer.getBounds());
    }
  }, [map]);

  function isPointInPolygon(point, polygon) {
    const x = point[0],
      y = point[1];
    let inside = false;
    for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
      const xi = polygon[i][0],
        yi = polygon[i][1];
      const xj = polygon[j][0],
        yj = polygon[j][1];
      const intersect = yi > y !== yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi || 1e-6) + xi;
      if (intersect) inside = !inside;
    }
    return inside;
  }

  function checkInZone(lon, lat) {
    const point = [lon, lat];
    let found = false;
    if(map){
      map.eachLayer((layer) => {
        if (layer instanceof L.GeoJSON) {
          layer.eachLayer((geoLayer) => {
            const geom = geoLayer.feature.geometry;
            if (geom.type === 'Polygon') {
              if (isPointInPolygon(point, geom.coordinates[0])) found = true;
            } else if (geom.type === 'MultiPolygon') {
              for (const poly of geom.coordinates) {
                if (isPointInPolygon(point, poly[0])) found = true;
              }
            }
          });
        }
      });
    }
    return found;
  }

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    console.log(file);

    setInCount(null);
    setOutCount(null);
    setAddressNotFoundCount(null);

    // Clear existing markers
    markers.forEach((marker) => {
      if (map && map.hasLayer(marker)) {
        map.removeLayer(marker);
      }
    });
    setMarkers([]);

    Papa.parse(file, {
      header: false,
      skipEmptyLines: true,
      complete: (results) => {
        const rows = results.data;
        const markerBounds = new L.LatLngBounds(); // Create bounds to fit markers

        rows.forEach((row, i) => {
          console.log(row[0]);
          if (!row[0]) return;
          setTimeout(() => {
            fetch(
              `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(
                row[0]
              )}`
            )
              .then((res) => res.json())
              .then((loc) => {
                if (!loc.length){
                  setAddressNotFoundCount((prev) => prev + 1);
                  return;
                }
                const lat = parseFloat(loc[0].lat);
                const lon = parseFloat(loc[0].lon);

                const inside = checkInZone(lon, lat);
                if(map){
                  const newMarker = L.circleMarker([lat, lon], {
                    radius: 6,
                    fillColor: inside ? '#2ecc71' : '#e74c3c',
                    color: '#333',
                    fillOpacity: 0.9,
                  }).addTo(map);

                  const label = inside ? '✅ In Zone' : '❌ Out of Zone';
                  newMarker.bindPopup(
                    `<strong>Address</strong><br>${row[0]}<br>${label}`
                  );
                  setMarkers((prevMarkers) => [...prevMarkers, newMarker]);
                  markerBounds.extend([lat, lon]); // Extend bounds to include marker
                  if(rows.length - 1 === i){// Fit map to marker bounds after all rows are executed
                    map.fitBounds(markerBounds);
                  }
                }

                inside ? setInCount((prev) => prev + 1) : setOutCount((prev) => prev + 1);
              });
          }, i * 800);
        });
      },
    });
  };

  return (
    <>
      <div className='flex flex row justify-between items-center'>
        <div className="chart-title" style={{ padding: "12px" }}>Upload file to check multiple address</div>
        <div className="relative">
          <div id="controls">
            <input type="file" id="csvUpload" accept=".csv" onChange={handleFileUpload} />
            <div id="results">
              {inCount && <>✅ In Zone: {inCount}</>}
              {outCount && <><br />
              ❌ Out of Zone: {outCount}</>}
              {addressNotFoundCount && <><br />
              ❗ Address Not Found: {addressNotFoundCount}</>}
            </div>
          </div>
        </div>
      </div>
      <section>
        <div id="uploadmap"></div>
      </section>
    </>
  );
}

export default UploadAddressChecker;